import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import _ from 'lodash'
import { ProgressRing } from 'ziphy-web-shared/basic/lib/loaders'

import BaseImage from '@library/media/mediaTypes/base/BaseImage'

import styles from './Types.module.scss'

const Image = ({ src, srcSet, fallbackSrc, onIsLoading }) => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(true)
  const [isDefault, setIsDefault] = useState(false)
  const [isError, setIsError] = useState(false)

  const changeIsLoading = (value) => {
    setIsLoading(value)

    if (_.isFunction(onIsLoading)) {
      onIsLoading(value)
    }
  }

  return (
    <div
      className={classNames(
        styles.image,
        isLoading && styles.isLoading,
        isDefault && styles.isDefault,
        isError && styles.isError,
      )}
    >
      <BaseImage
        src={src}
        srcSet={srcSet}
        fallbackSrc={fallbackSrc}
        onIsLoading={changeIsLoading}
        onIsDefault={setIsDefault}
        onIsError={setIsError}
      />
      {isDefault && (
        <div className={styles.defaultContent}>
          <div className={styles.icon} />
          <div className={styles.text}>{t('errors.preview_unavailable')}</div>
        </div>
      )}
      {isLoading && (
        <ProgressRing
          radius={28}
          progress={25}
          spin={true}
          centered={true}
          className={styles.loader}
        />
      )}
    </div>
  )
}

export default Image
